import { render, staticRenderFns } from "./DetalhesAtendimento.vue?vue&type=template&id=2425ae96"
import script from "./DetalhesAtendimento.vue?vue&type=script&lang=js"
export * from "./DetalhesAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports